import { constructEnum } from '@/lib/enum';

const SpamType = constructEnum('SpamType', {
  PLAGIARISM: 0,
  LIBEL: 10,
  ETC: 20,
  ADVERTISING: 30,
  HATE_OR_VIOLENCE: 40,
  MISINFORMATION: 50,
  HARM_TO_MINOR: 60,
  PRIVACY: 70
});

export default {
  ...SpamType,
  articleSpamTypes: [
    SpamType.PLAGIARISM,
    SpamType.LIBEL,
    SpamType.ADVERTISING,
    SpamType.HATE_OR_VIOLENCE,
    SpamType.MISINFORMATION,
    SpamType.ETC
  ],
  brandUserSpamTypes: [
    SpamType.PLAGIARISM,
    SpamType.LIBEL,
    SpamType.HARM_TO_MINOR,
    SpamType.HATE_OR_VIOLENCE,
    SpamType.PRIVACY,
    SpamType.ETC
  ]
};
